import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  trigger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: '100px',
    padding: '6px 12px',
    border: `1px solid ${foundations.colors.gray300}`,
    borderRadius: '4px',
    backgroundColor: foundations.colors.white,
    cursor: 'pointer',
    minHeight: '36px',
    '&:hover': {
      borderColor: foundations.colors.gray500,
    },
    '&[aria-disabled=true]': {
      backgroundColor: foundations.colors.gray50,
      cursor: 'not-allowed',
      color: foundations.colors.gray400,
    },
  },
  triggerLabel: {
    flex: 1,
    fontSize: '14px',
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  triggerIcon: {
    fontSize: '18px',
    color: foundations.colors.gray500,
    flexShrink: 0,
  },
  popoverPaper: {
    width: 'var(--trigger-width)',
    border: `1px solid ${foundations.colors.gray300}`,
    borderRadius: '4px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
  },
  filterBox: {
    padding: '8px',
    borderBottom: `1px solid ${foundations.colors.gray200}`,
  },
  treeBox: {
    overflowY: 'auto',
    flex: 1,
  },
  nodeButton: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '4px',
    borderRadius: 0,
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: foundations.colors.blue50,
    },
  },
  nodeButtonDisabled: {
    opacity: 0.5,
    cursor: 'default',
  },
  nodeLabel: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '14px',
  },
  toggleIcon: {
    fontSize: '18px',
    flexShrink: 0,
    color: foundations.colors.gray500,
  },
  toggleIconPlaceholder: {
    width: '18px',
    flexShrink: 0,
  },
  disabledLabel: {
    color: foundations.colors.gray400,
    fontSize: '12px',
    flexShrink: 0,
  },
});
